"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8c0-2.7614 2.2386-5 5-5 2.6087 0 4.7508 1.9978 4.9797 4.547A3.9818 3.9818 0 0 1 14 7c2.2091 0 4 1.7909 4 4 0 1.8638-1.2748 3.4299-3 3.874v2.7651C17.3595 18.4201 19.6901 19 22 19v2c-3.7074 0-7.6689-1.4314-11.0186-2.6721C7.6634 17.0982 4.7004 16 2 16v-2c1.3047 0 2.6459.2194 4 .5619V12.9c-2.2822-.4633-4-2.481-4-4.9zm5-3C5.3431 5 4 6.3431 4 8s1.3431 3 3 3 3-1.3431 3-3-1.3431-3-3-3zm1 10.1438c1.6854.5452 3.3357 1.191 5 1.7962v-2.066c-1.4327-.3688-2.5547-1.5112-2.894-2.9555A4.9799 4.9799 0 0 1 8 12.9v2.2438zM14 9c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2z"
  })];
};

exports.default = _default;